export default __webpack_public_path__ + "static/media/threesteps1.0bfc54a0.jpg";